/**
 * BioBackground — renders floating orb blobs for "orbs" type backgrounds.
 * Returns null for all other background types (handled via CSS on the wrapper).
 *
 * Props: { theme } — a theme object from THEME_ENGINE
 */
export function BioBackground({ theme }) {
  if (!theme?.background || theme.background.type !== "orbs") return null;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {theme.background.orbs.map((orb, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: orb.x,
            top: orb.y,
            width: orb.size,
            height: orb.size,
            borderRadius: "50%",
            background: orb.color,
            filter: `blur(${orb.blur}px)`,
            animation: `bio-orb-${(i % 3) + 1} ${orb.duration}s ease-in-out infinite`,
            animationDelay: `${orb.delay}s`,
            opacity: orb.opacity,
            willChange: "transform",
          }}
        />
      ))}
    </div>
  );
}
